<template>
  <img
    :src="LoyaltyIconSvgPlatinum"
    alt="loyalty-macys-platinum-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgPlatinum from '@core/csg/src/assets/images/mcom/compressed/loyalty-macys-platinum-small.svg';
</script>
